import { Box, Button, Rating, TextField, Typography } from "@mui/material";
import React from "react";

const RateChat = () => {
  const [value, setValue] = React.useState<number | null>(null);
  return (
    <Box
      sx={{
        padding: "24px",
      }}
    >
      <Typography
        sx={{
          color: (theme) => theme.palette.primary.main,
          fontWeight: "bold",
          mt: 3,
        }}
        variant="body2"
      >
        Wie zufrieden bist du mit diesem Service?
      </Typography>

      <Rating
        sx={{
          mt: 2,
        }}
        name="simple-controlled"
        aria-label="Wie zufrieden bist du mit diesem Service?" // A11Y FIX
        value={value}
        size="large"
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      />

      <Typography
        sx={{
          color: (theme) => theme.palette.primary.main,
          fontWeight: "bold",
          mt: 5,
        }}
        variant="body2"
      >
        Feedback
      </Typography>

      <TextField
        sx={{
          mt: 1,
        }}
        fullWidth
        multiline
        id="rating-feedback"
        label="Teile dein Feedback mit uns"
        variant="standard"
      />

      <Button
        sx={{
          mt: 5,
        }}
        variant="contained"
      >
        Absenden
      </Button>
    </Box>
  );
};

export default RateChat;
